import { request } from '../utils';

export default function editAdd(root: any, data: any, id, calback) {
    request(root, data).then((rd) => {
        if (rd.errCode == 200) {
            calback && calback(true, '新增地址成功', rd.data);
        } else {
            calback && calback(false, rd.errDesc);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/editadd.ts